import {CSSProperties} from '../../../styleSheet';
import {withCaching} from '../../../utils';
import {BaseAllCategoryProps, StyleCategoryName} from '../types';
import {StyleCategoryMap} from './StyleCategoryMap';

const getStyleCategoriesInternal = (
  categories: StyleCategoryName[],
  props: BaseAllCategoryProps,
): CSSProperties => {
  const styleCategories = categories.reduce(
    (acc, c) => ({
      ...acc,
      ...StyleCategoryMap[c].dynamicPropFactory(props),
    }),
    {},
  );

  return styleCategories;
};

export const getStyleCategories = withCaching(getStyleCategoriesInternal);
